angular.module('zc.core')
  .factory('ChartV2', ChartV2);

ChartV2.$inject = [];
function ChartV2() {
  class Chart {
    constructor(config, customConfig) {
      this.config = _.merge({
        options: { rand: Math.random() }
      }, config, customConfig);
    }

    getConfig() {
      return this.config;
    }

    resetSeries() {
      this.config.series = [];
    }

    addSeries(series) {
      this.config.series.push(series);
    }
  }
  return Chart;
}



// WEBPACK FOOTER //
// ../app_shared/src/shared_modules/core/services/chart_v2.service.js